import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, ToastController, LoadingController, Events, normalizeURL, AlertController, Platform } from 'ionic-angular';
import { CadastroModel } from './cadastro.modelview';
import { FormBuilder, Validators, FormGroup } from '@angular/forms';
import { CadastroPageProvider } from './cadastro.provider';
import { LoginPage } from '../login/login';
import { Camera, CameraOptions } from '@ionic-native/camera';
import { DomSanitizer } from '@angular/platform-browser';
import { FilePath } from '@ionic-native/file-path';
import { environment } from '../../environments/environment.dev';

@IonicPage()
@Component({
  selector: 'page-cadastro',
  templateUrl: 'cadastro.html',
})

export class CadastroPage {

  private isEdition: boolean = false;
  private loginForm: FormGroup;
  private model: CadastroModel = new CadastroModel()

  private originalUrlPhoto: string;
  private noNormalizedImage: string;

  private userId: string;

  isPlatformBrowser = false
  isToSelectFile = false

  title: string = "Cadastro";

  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    public formBuilder: FormBuilder,
    public cadastroPageProvider: CadastroPageProvider,
    private toastCtrl: ToastController,
    private alertController: AlertController,
    private camera: Camera,
    public event: Events,
    private filePath: FilePath,
    private platform: Platform,
    public sanitizen: DomSanitizer,
    public loadingCtrl: LoadingController) {

    this.isPlatformBrowser = this.platform.is('core') || this.platform.is('mobileweb')

    this.loginForm = formBuilder.group({
      nome: ['', Validators.compose([Validators.minLength(2), Validators.required])],
      estado: ['', Validators.required],
      crm: ['', Validators.required],
      especialidade: ['', Validators.required],
      interesse: ['', Validators.required],
      endereco: [''],
      telefone: ['', Validators.required],
      email: ['', Validators.compose([Validators.minLength(4), Validators.pattern('^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+.[a-zA-Z0-9-.]+$'), Validators.required])],
      senha: ['', Validators.compose([Validators.minLength(6), Validators.required])],
      opcao_contato: ['', Validators.required],
    });

    this.model.estados = []
    this.model.especialidades = []
    this.model.opcoes_contato = []
    this.model.foto = "assets/imgs/avatar-default.png"
    this.solicitarListas()

    this.isEdition = navParams.get("isEdition")

    if (this.isEdition != undefined) {
      let user = this.cadastroPageProvider.getPersistedUser()
      this.isEdition = true;
      this.title = "Editar"

      this.userId = user.general.data.ID
      this.model.nome = user.general.data.display_name
      this.model.email = user.general.data.user_email
      this.model.estado = user.acf["uf"]
      this.model.crm = user.acf["crm-medico"]
      this.model.especialidade = user.acf["especialidades_medico"]
      this.model.interesse = user.acf["areas_interesse"]
      this.model.endereco = user.acf["endereco"]
      this.model.telefone = user.acf["celular"]
      this.model.opcao_contato = user.acf["opcao_contato"]

      if (user.acf.foto != undefined) {

        if (user.acf.foto.indexOf("http") > -1) {
          this.model.foto = user.acf.foto
        } else {
          this.model.foto = environment.principal_link + user.acf.foto
        }
      } else {
        this.model.foto = "assets/imgs/avatar-default.png"
      }

      this.originalUrlPhoto = this.model.foto

      this.loginForm.removeControl("senha")
    }

  }

  registrarUsuario() {
    let loading = this.loadingCtrl.create({
      content: 'Cadastrando...'
    });
    loading.present()

    if (this.isPlatformBrowser) {
      this.sendUserData(loading)
      return
    }

    if (this.model.foto != "assets/imgs/avatar-default.png") {

      var imageUri = this.noNormalizedImage == undefined? this.model.foto : this.noNormalizedImage

      this.cadastroPageProvider.sendImage(imageUri).subscribe(data => {
        console.log("sendImage", data)
        this.model.foto = data.replace(environment.principal_link, "")
        this.sendUserData(loading)
      }, error => {
        loading.dismiss().then(() => {
          this.showErrorDialog(error.message)
        })
      })
    } else {
      this.sendUserData(loading)
    }
  }

  sendUserData(loading) {
    this.cadastroPageProvider.registerUser(this.model).subscribe(() => {
      loading.dismiss().then(() => {
        let toast = this.toastCtrl.create({
          message: "Registrado com sucesso! Efetue o login",
          duration: 3000,
          position: 'bottom'
        });
        toast.present()
        this.navCtrl.setRoot(LoginPage, {
          "email": this.model.email
        })
      })
    }, error => {
      loading.dismiss().then(() => {
        this.showErrorDialog("Não foi possivel cadastrar seus dados, verifique se você está conectado a internet e certifique-se de que o e-mail não seja um já utilizado anteriormente.")
      })
    })
  }

  solicitarListas() {

    let loading = this.loadingCtrl.create({
      content: 'Loading'
    });
    loading.present()

    this.cadastroPageProvider.requestLists().subscribe((data) => {
      loading.dismiss().then(() => {
        this.model.especialidades = data.especialidades_medico
        this.model.interesses = data.areas_interesse
        this.model.estados = data.estados
        this.model.opcoes_contato = data.opcoes_contato
      })
    }, err => {
      loading.dismiss().then(() => {
        this.showErrorDialog(err.message)
      })
    })
  }

  getPhoto() {

    if (this.isPlatformBrowser) {
      return
    }

    const options: CameraOptions = {
      quality: 50,
      destinationType: this.camera.DestinationType.FILE_URI,
      encodingType: this.camera.EncodingType.JPEG,
      mediaType: this.camera.MediaType.PICTURE,
      correctOrientation: true,
      sourceType: this.camera.PictureSourceType.PHOTOLIBRARY,
      saveToPhotoAlbum: true
    }

    let loading = this.loadingCtrl.create({
      content: 'Loading'
    });
    loading.present()

    this.camera.getPicture(options).then((imageData) => {
      //  imageData = "data:image/jpeg;base64," + imageData
      this.model.foto = normalizeURL(imageData)

      if (this.platform.is("ios"))
        this.noNormalizedImage = imageData

      loading.dismiss()
    }).catch(err => {
      loading.dismiss()
    })
  }

  showErrorDialog(mess: string) {
    let alert = this.alertController.create({
      title: 'Erro',
      message: mess,
      buttons: [
        {
          text: 'Fechar',
          role: 'cancel',
          handler: () => {
            alert.dismiss()
          }
        }
      ],
      enableBackdropDismiss: false
    });
    alert.present();
  }

  updateUser() {
    let loading = this.loadingCtrl.create({
      content: 'Atualizando...'
    });
    loading.present()

    if (this.isPlatformBrowser) {
      this.updateUserData(loading)
      return
    }

    if (this.model.foto != "assets/imgs/avatar-default.png" && this.model.foto != this.originalUrlPhoto) {

      var imageUri = this.noNormalizedImage == undefined? this.model.foto : this.noNormalizedImage

      this.cadastroPageProvider.sendImage(imageUri).subscribe(data => {
        console.log("sendImage", data)
        this.model.foto = data.replace(environment.principal_link, "")
        this.updateUserData(loading)
      }, error => {
        loading.dismiss()
        this.showErrorDialog(error.message)
      })

    } else {
      this.updateUserData(loading)
    }
  }

  updateUserData(loading) {
    this.cadastroPageProvider.editUser(this.userId, this.model).subscribe(() => {

      loading.dismiss().then(() => {
        let toast = this.toastCtrl.create({
          message: "Atualizado com sucesso!",
          duration: 3000,
          position: 'bottom'
        });
        toast.present()
        this.event.publish("user:updated")
        this.navCtrl.pop()
      })
    }, error => {
      loading.dismiss()
      this.showErrorDialog(error.message)
    })
  }

  startLogout() {
    this.alertController.create({
      title: "Deslogar",
      message: "Tem certeza que deseja deslogar?",
      buttons: [{
        text: "Sim",
        handler: () => { this.logout() }
      }, {
        text: "Não",
      }
      ]
    }).present()

  }

  changeListener(event: any) {

    let loading = this.loadingCtrl.create({
      content: 'Aguarde...'
    });
    loading.present().then(() => {
      console.log("Selected Image", event)
      let file = event.target.files[0];
      console.log("Selected Image file", file)

      this.cadastroPageProvider.sendImageFile(file).subscribe(data => {
        console.log("sendImage", data)
        this.model.foto = data
        loading.dismiss()
      }, error => {
        loading.dismiss()
      })
    })
  }

  logout() {
    this.cadastroPageProvider.logout()
    this.navCtrl.setRoot(LoginPage)
  }
}


// WEBPACK FOOTER //
// ./src/pages/cadastro/cadastro.ts